import { LoaderCircleIcon } from 'lucide-react'
import { useMemo } from 'react'

import { useEmployerRenewalConfig } from 'apps/employer_renewals/providers/EmployerRenewalConfigProvider'
import { useGetEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummary as useGetRateSummary } from 'utils/web_api'

import RateSummaryItem from './RateSummaryItem'

export default function RateChangeSummary () {
  const { employerRenewalConfig, isLoading: isLoadingRenewalConfig } = useEmployerRenewalConfig()
  const { data: rateSummary, isLoading: isLoadingRateSummary } = useGetRateSummary(employerRenewalConfig?.id ?? '', { query: { enabled: !!employerRenewalConfig?.id } })

  const isLoading = isLoadingRenewalConfig || isLoadingRateSummary

  const orderedRateSummaries = useMemo(() => {
    if (!rateSummary?.data) {
      return []
    }

    return rateSummary.data.sort((a, b) => {
      if (a.has_finalized_rates !== b.has_finalized_rates) {
        return a.has_finalized_rates ? -1 : 1
      }

      return a.state_abbreviation.localeCompare(b.state_abbreviation)
    })
  }, [rateSummary])

  return (
    <div className='flex flex-col gap-4 border border-gray-200 rounded-2xl p-6 bg-gray-50 shadow-sm'>
      <div className='body text-gray-500'>Rate Change Summary</div>
      <p className='body-sm'>Health insurance prices in 2026 are increasing mainly due to higher medical costs, expensive new treatments, and policy uncertainty from the expiration of federal subsidies, prompting insurers to price more cautiously.</p>
      <div className='bg-gray-200 h-[1px] w-full' />
      {isLoading
        ? (
          <div className='flex justify-center items-center gap-2'>
            <LoaderCircleIcon size={24} className='animate-spin text-gray-500' />
            <span className='body-sm text-gray-500'>Loading rate changes...</span>
          </div>
          )
        : (
          <>
            <div className='body text-gray-500'>Average rate changes where your employees live:</div>
            {orderedRateSummaries.map((rateSummary) => (
              <RateSummaryItem key={rateSummary.state_abbreviation} rateSummary={rateSummary} />
            ))}
          </>
          )}
    </div>
  )
}
